import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section id="faq" className="mx-auto max-w-3xl scroll-mt-24 px-5 py-20 sm:px-8 lg:py-28">
      <Reveal className="text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.15em] text-marigold-deep">FAQ</p>
        <h2 className="mt-3 font-heading text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">
          Questions, answered
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-10">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-b border-border">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-heading text-lg font-medium text-foreground hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-base leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
